export const visit = (vm, at) => {
at({ "it": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Siamo spiacenti, ma non \xE8 stato possibile verificare il tuo indirizzo e-mail." } } } });
};